import * as tslib_1 from "tslib";
import api from '../api';
import Task from '../models/Task';
import { TimeItem } from '../models/TimeItem';
import CheckListItemStatus from '../models/CheckListItemStatus';
import { TaskStatus } from '../models/TaskStatus';
import Statistic from '../models/Statistic';
import NfcTask from '../models/NfcTask';
var endPoints = {
    sprint: 'api/sprint',
    statistic: 'api/statistic',
    taskStatus: 'api/task/statuses',
    task: 'api/task/',
    tasks: 'api/task/all',
    filteredTasks: 'api/task/filter',
    updateStatus: 'api/task/status',
    updatePercentage: 'api/task/percentage',
    updateDescription: 'api/task/description',
    updateRating: 'api/task/rating',
    addItem: 'api/task/item/add',
    updateItem: 'api/task/item/update',
    deleteItem: 'api/task/item/delete',
    checkListStatus: 'api/task/checklist/statuses',
    updateCheckListItem: 'api/task/checklist/',
    create: 'api/task/create/',
    deleteTask: 'api/task/delete',
    nfcTasks: 'api/task/allnfctasks',
    updateNfcTask: 'api/task/updatenfctask',
    taskAction: 'api/task/taskaction'
};
var TaskApi = /** @class */ (function () {
    function TaskApi() {
    }
    TaskApi.getTaskStatuses = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.taskStatus)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return new TaskStatus(i); })];
                }
            });
        });
    };
    TaskApi.getCheckListItemStatuses = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.checkListStatus)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return new CheckListItemStatus(i); })];
                }
            });
        });
    };
    TaskApi.getSprint = function (sprinIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.sprint + "/" + sprinIndex)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TaskApi.get = function (taskId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.task + taskId.toString())];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Task(data)];
                }
            });
        });
    };
    TaskApi.getAll = function (userId, sprintIndex, isDisplayClosedTasks) {
        if (isDisplayClosedTasks === void 0) { isDisplayClosedTasks = false; }
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.tasks, {
                            userId: userId,
                            sprintIndex: sprintIndex,
                            isDisplayClosedCards: isDisplayClosedTasks
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return new Task(i); })];
                }
            });
        });
    };
    TaskApi.getStatistic = function (userId, sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.statistic, {
                            userId: userId,
                            sprintIndex: sprintIndex
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Statistic(data)];
                }
            });
        });
    };
    TaskApi.updateStatus = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updateStatus, task)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TaskApi.updatePercentage = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updatePercentage, task)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.updateRating = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updateRating, task)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TaskApi.updateDescription = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updateDescription, task)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.addItem = function (item) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.addItem, item)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new TimeItem(data)];
                }
            });
        });
    };
    TaskApi.deleteItem = function (item) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.deleteItem, item)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.updateCheckListItem = function (item) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updateCheckListItem, {
                            id: item.id,
                            headId: item.headId,
                            name: item.name,
                            statusId: item.statusId,
                            note: item.note,
                            insertDate: item.insertDate,
                            modifyDate: item.modifyDate
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.getCreateModel = function (userId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.create + userId.toString())];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TaskApi.createModel = function (userId, task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.create + userId.toString(), task)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Task(data)];
                }
            });
        });
    };
    TaskApi.getNfcTasks = function (userId, sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.nfcTasks, {
                            userId: userId,
                            sprintIndex: sprintIndex
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return new NfcTask(i); })];
                }
            });
        });
    };
    TaskApi.updateNfcTask = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.updateNfcTask, task)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.deleteTask = function (task) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.deleteTask, task)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status !== 500];
                }
            });
        });
    };
    TaskApi.taskAction = function (action) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.taskAction, action)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskApi.taskHistory = function (taskID) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("api/task/" + taskID + "/history")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return TaskApi;
}());
export default TaskApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/TaskApi.ts
// module id = 36
// module chunks = 0